import React from 'react'
import ReactDOM from 'react-dom/client'
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from 'react-router-dom'
import './index.css';
import App from './App';

import './style.css';
import store from "./redux/store";
import { Provider } from "react-redux";
import reportWebVitals from './reportWebVitals';
import 'flag-icons/css/flag-icons.min.css';

const registerServiceWorker = () => {
  // Use process.env.NODE_ENV === 'production' for CRA
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      // Assuming service-worker.js is in the public folder for CRA
      navigator.serviceWorker.register('/service-worker.js')
        .then(registration => {
          console.log('Service Worker registered with scope:', registration.scope);
        })
        .catch(error => {
          console.error('Service Worker registration failed:', error);
        });
    });
  }
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// Register service worker - Uncomment if needed for your PWA features
// registerServiceWorker();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


// const App = () => {
//   return (
//     <Router>
//       <Provider store={store}>
//         <Routes>
//           {/* <Route component={Pharmacy} exact path="/" /> */}
//           <Route element={<Pharmacy />} path="/" />
//           <Route element={<Login />} path="/login" />
//           <Route element={<ListProduct />} path="/listProduct/:category" />

//           <Route element={<ListProduct />} path="/listProduct/:category" />


//           {/* <Redirect to="**" /> */}
//         </Routes>
//       </Provider>
//     </Router>
//   )
// }

// // ReactDOM.render(<App />, document.getElementById('app'))
// const root = ReactDOM.createRoot(document.getElementById("app"));
// root.render(<App />);